import { render } from "./page_404.vue?vue&type=template&id=8b3742d2&scoped=true"
import script from "./page_404.vue?vue&type=script&lang=js"
export * from "./page_404.vue?vue&type=script&lang=js"

import "./page_404.vue?vue&type=style&index=0&id=8b3742d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3742d2"]])

export default __exports__